module.exports = __webpack_public_path__ + "_/skins/Vizor1-01-0985438a88963f6803311ed99b17f7f4.wsz";